import { render, staticRenderFns } from "./DocFieldList.vue?vue&type=template&id=518902af&scoped=true&"
import script from "./DocFieldList.vue?vue&type=script&lang=js&"
export * from "./DocFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518902af",
  null
  
)

export default component.exports